import * as types from '../types.js'
import commons from '@/util/commons.js';
export default {
	//更新state
	//修改书本的名称
	[types.MAKE_SET_SEO]:(state,val)=>{
		state.seoInfo = val;
	}
}


// WEBPACK FOOTER //
// ./src/store/asset/mutations.js